<template>
  <div class="merchant-dashboard-sidebar">
    <div class="logo">
      <a href="/">
        <img src="amej-pay.png" width="" height="" alt="Amejpay" />
      </a>
    </div>
    <div class="header-elements">
      <ul class="side-links">
        <router-link :to="{ name: 'merchant-dashboard' }"
          ><span class="material-icons"> dashboard </span
          ><span>Dashboard</span></router-link
        >
        <router-link :to="{ name: 'merchant-user-details' }"
          ><span class="material-icons"> people </span
          ><span>User Details</span></router-link
        >
        <a href="#" v-b-toggle.collapse-3>
          <div class="d-flex flex-grow-1 align-items-center">
            <div class="col pl-0">
              <p>
                <span class="material-icons"> payment </span>
                <span class="text">Transaction</span>
              </p>
            </div>
            <div class="col-2">
              <span class="material-icons"> navigate_next </span>
            </div>
          </div>
        </a>
        <b-collapse id="collapse-3" class="m-0">
          <router-link
            class="bg-gray"
            :to="{ name: 'merchant-success-transaction' }"
            ><h5>Success Transaction</h5>
          </router-link>
          <router-link
            class="bg-gray"
            :to="{ name: 'merchant-failed-transaction' }"
            ><h5>Failed Transaction</h5>
          </router-link>
        </b-collapse>
        <router-link :to="{ name: 'merchant-withdraw' }"
          ><span class="material-icons"> local_atm </span
          ><span>Withdraw</span></router-link
        >
        <router-link :to="{ name: 'merchant-statement' }"
          ><span class="material-icons"> receipt_long </span
          ><span>Statement</span></router-link
        >
        <a href="#">
          <div
            class="d-flex flex-grow-1 align-items-center"
            v-b-toggle.collapse-2
          >
            <div class="col pl-0">
              <p>
                <span class="material-icons"> settings </span>
                <span class="text">Settings</span>
              </p>
            </div>
            <div class="col-2">
              <span class="material-icons"> navigate_next </span>
            </div>
          </div>
        </a>
        <b-collapse id="collapse-2" class="m-0">
          <router-link class="bg-gray" :to="{ name: 'merchant-settings-key' }"
            ><h5>Key</h5>
          </router-link>
          <router-link class="bg-gray" :to="{ name: 'merchant-settings-url' }"
            ><h5>Url</h5>
          </router-link>
          <router-link class="bg-gray" :to="{ name: 'merchant-bank' }"
            ><h5>Bank</h5>
          </router-link>
          <router-link class="bg-gray" :to="{ name: 'merchant-qr' }"
            ><h5>QR Code</h5>
          </router-link>
        </b-collapse>
        <router-link :to="{ name: 'merchant-kyc' }"
          ><span class="material-icons"> verified_user </span
          ><span>{{ kycMenuLabel }}</span></router-link
        >
        <router-link :to="{ name: 'merchant-documents' }"
          ><span class="material-icons"> picture_as_pdf</span
          ><span>Documents</span></router-link
        >
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["profile"]),
    kycStatus: function () {
      const a = this.profile && this.profile.author;
      return (a && a.kyc_status) ? a.kyc_status : "";
    },
    isKycVerified: function () {
      const a = this.profile && this.profile.author;
      return !!(a && a.is_kyc_verified === true);
    },
    // verified -> view only | pending -> still editable | otherwise -> not submitted yet
    kycMenuLabel: function () {
      if (this.isKycVerified) { return "KYC Details"; }
      if (["pending", "submitted", "rejected"].indexOf(this.kycStatus) !== -1) { return "Update KYC"; }
      return "Complete KYC";
    },
  },
};
</script>
<style lang="scss" scoped>
.merchant-dashboard-sidebar {
  display: grid;
  grid-gap: 40px;
  padding: 50px 50px;
  .logo {
    img {
      height: 70px;
      max-width: 100%;
      object-fit: cover;
    }
  }

  .header-elements {
    .side-links {
      display: grid;
      grid-gap: 10px;
      p {
        margin-bottom: 0px;
        display: flex;
        .text {
          color: #666666;
          font-size: 16px;
        }
      }
      .router-link-exact-active {
        background: #f1f8ff;
        color: #0066b3;
        border-radius: 5px;
      }
      a {
        color: #666666;
        display: flex;
        align-items: center;
        padding: 16px 10px;
        text-decoration: none;
      }
      .material-icons {
        color: #666666;
      }
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    .bg-gray {
      background-color: #f1f8ff;
      &:hover {
        background-color: #fff;
        color: #000;
      }
    }
  }
}
</style>